import lottie from "lottie-web/build/player/lottie_light";

const Animation = () => {
    const animations = document.querySelectorAll(".js-animation");

    if (!animations.length) {
        return false;
    }

    animations.forEach((animationEl) => {
        const animationType = animationEl.getAttribute("data-animation");

        if (animationType) {
            lottie.loadAnimation({
                container: animationEl,
                renderer: "svg",
                loop: true,
                autoplay: true,
                path: `/_resources/themes/community-hub/dist/images/animations/${animationType}/${animationType}.json`,
            });
        }
    });
};

export default Animation;
